<template>
  <div class="EscuelaDetalleContactos">
    <md-card>
      <md-card-header>
        <md-card-header-text>
          <div class="md-title">Contactos</div>
        </md-card-header-text>
        <md-button
          v-if="$session.get('tipo') != 'otro'"
          class="md-icon-button md-raised md-primary"
          @click="dialogContactosForm = true"
        >
          <md-icon>add</md-icon>
        </md-button>
      </md-card-header>
      <md-list class="md-triple-line">
        <div
          v-for="(item,index) in contactos"
          :key="index"
        >
          <md-list-item>
            <md-avatar
              class="upper"
              v-text=""
            >
              {{item.puesto_eco.charAt(0)}}
            </md-avatar>
            <div class="md-list-item-text">
              <span class="upper">{{item.nombre_eco}}</span>
              <span>{{item.tel_eco}}</span>
              <p>{{item.email_eco}}</p>
            </div>
            <md-button
              v-if="$session.get('tipo') != 'otro'"
              class="md-icon-button md-list-action"
              @click="_editar(item,index)"
            >
              <md-icon class="md-primary">edit</md-icon>
            </md-button>
          </md-list-item>
          <md-divider v-if="index + 1 < contactos.length" />
        </div>
      </md-list>
    </md-card>
    <Loading v-if="cargando" />

    <md-dialog :md-active.sync="dialogContactosForm">
      <md-dialog-title>{{contacto.id ? 'Editar' : 'Registrar'}} contacto</md-dialog-title>
      <md-dialog-content>
        <md-field :class="errores.nombre_eco">
          <label>Nombre</label>
          <md-input
            v-model="contacto.nombre_eco"
            required
          />
        </md-field>
        <md-field :class="errores.puesto_eco">
          <label>Puesto</label>
          <md-select
            v-model="contacto.puesto_eco"
            md-dense
            required
          >
            <md-option value="director">Director</md-option>
            <md-option value="subdirector">Subdirector</md-option>
            <md-option value="supervisor">Supervisor</md-option>
            <md-option value="maestro">Maestro</md-option>
            <md-option value="otro">Otro</md-option>
          </md-select>
        </md-field>
        <md-field
          :class="errores.tel_eco"
          :md-counter="false"
        >
          <md-icon>phone</md-icon>
          <label>Teléfono</label>
          <md-input
            v-model="contacto.tel_eco"
            v-mask="`(###) ###-####`"
            maxlength="14"
            type="tel"
            required
          />
        </md-field>
        <md-field :class="errores.email_eco">
          <md-icon>mail_outline</md-icon>
          <label>Email</label>
          <md-input
            v-model="contacto.email_eco"
            type="email"
          />
        </md-field>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button @click="dialogContactosForm=false">Cancelar</md-button>
        <md-button
          class="md-raised md-primary"
          @click="_presave"
        >{{contacto.id?'Actualizar':'Guardar'}}</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>
<script>
const toLower = text => {
  return text.toString().toLowerCase();
};
const buscarUsr = (items, term) => {
  if (term) {
    return items.filter(item =>
      toLower(item.descripcion).includes(toLower(term))
    );
  }
  return items;
};
import Loading from "@/components/Loading";
export default {
  name: "EscuelaDetalleContactos",
  props: {
    escuela: Object
  },
  components: { Loading },
  methods: {
    buscarEnLaTabla() {
      this.filtroContactos = buscarUsr(this.motivos, this.buscar);
    },
    _falloResponse(err) {
      this.cargando = false;
      if (err.status === 401) {
        this.$router.push("/login");
      } else {
        this.$emit("msg", this.$no_internet);
      }
    },
    _obtenerContactos() {},
    _validar() {
      this.errores.nombre_eco = this.$mdError(this.contacto.nombre_eco);
      this.errores.puesto_eco = this.$mdError(this.contacto.puesto_eco);
      this.errores.tel_eco = this.$mdError(this.contacto.tel_eco);
      return this.$validate(this.errores);
    },
    _presave() {
      if (this._validar()) {
        this.contacto.id ? this._actualizar() : this._guardar();
      } else {
        this.$emit("msg", this.$llene_campos);
      }
    },
    _guardar() {
      this.cargando = true;
      let idTemporal = "c." + this.$moment();
      this.contactos.push({
        id: idTemporal,
        id_esc_eco: this.escuela.id_esc,
        nombre_eco: this.contacto.nombre_eco,
        puesto_eco: this.contacto.puesto_eco,
        tel_eco: this.contacto.tel_eco,
        email_eco: this.contacto.email_eco
      });
      this.$emit("msg", "Contacto guardado");
      this.dialogContactosForm = false;
      this.cargando = false;
      this._guardarECO();
    },
    _editar(a) {
      this.contacto.id = a.id;
      this.contacto.nombre_eco = a.nombre_eco;
      this.contacto.puesto_eco = a.puesto_eco;
      this.contacto.tel_eco = a.tel_eco;
      this.contacto.email_eco = a.email_eco;
      this.dialogContactosForm = true;
    },
    _actualizar() {
      let id = this.contacto.id;
      let ix = this.contactos.findIndex(function(b) {
        return b.id === id;
      });
      if (ix >= 0) {
        let idc =
          this.contacto.id.charAt(1) === "."
            ? this.contacto.id
            : "u." + this.contacto.id;
        this.contactos[ix].id = idc;
        this.contactos[ix].nombre_eco = this.contacto.nombre_eco;
        this.contactos[ix].puesto_eco = this.contacto.puesto_eco;
        this.contactos[ix].tel_eco = this.contacto.tel_eco;
        this.contactos[ix].email_eco = this.contacto.email_eco;
        this.$emit("msg", "Contacto actualizado");
        this.dialogContactosForm = false;
        this._guardarECO();
      }
    },
    _guardarECO() {
      this.e_con[this.indexECO].escuelas_contactos = this.contactos;
      localStorage.setItem("escuelas_contactos", JSON.stringify(this.e_con));
    }
  },
  data() {
    return {
      buscar: null,
      dialogContactosForm: false,
      filtroContactos: [],
      contactos: [],
      contacto: {
        id: null,
        id_esc_eco: null,
        nombre_eco: null,
        puesto_eco: null,
        tel_eco: null,
        email_eco: null
      },
      errores: {
        nombre_eco: null,
        puesto_eco: null,
        tel_eco: null,
        email_eco: null
      },
      cargando: false,
      e_con: [],
      indexECO: null
    };
  },
  watch: {
    e_con(aa) {
      let idEscuela = this.$route.params.idEscuela;
      this.indexECO = aa.findIndex(function(b) {
        return b.escuela === idEscuela;
      });
      if (this.indexECO < 0) {
        this.e_con.push({ escuela: idEscuela, escuelas_contactos: [] });
        this.indexECO = this.e_con.length - 1;
      }
    },
    indexECO(a) {
      if (a >= 0) {
        this.contactos = this.e_con[a].escuelas_contactos;
      } else {
        this.contactos = [];
      }
    },
    contactos() {
      this.filtroContactos = this.contactos;
    },
    buscar(a) {
      this.buscarEnLaTabla();
    },
    dialogContactosForm(a) {
      if (!a) {
        this.contacto.id = null;
        this.contacto.id_eco = null;
        this.contacto.nombre_eco = null;
        this.errores.nombre_eco = null;
        this.contacto.puesto_eco = null;
        this.errores.puesto_eco = "director";
        this.contacto.tel_eco = null;
        this.errores.tel_eco = null;
        this.contacto.email_eco = null;
        this.errores.email_eco = null;
      }
    }
  },
  created() {
    let idEsc = this.$route.params.idEscuela;
    if (localStorage.getItem("escuelas_contactos")) {
      this.e_con = JSON.parse(localStorage.getItem("escuelas_contactos"));
    } else {
      let sett = [{ escuela: idEsc, escuelas_contactos: [] }];
      localStorage.setItem("escuelas_contactos", JSON.stringify(sett));
      this.e_con = JSON.parse(localStorage.getItem("escuelas_contactos"));
    }
  },
  beforeCreate() {
    if (!this.$session.exists()) {
      this.$emit("visible", false);
      this.$router.push("/login");
    } else {
      this.$emit("visible", true);
      this.$emit("classes", "container");
    }
  },
  beforeDestroy() {
    this._guardarECO();
  }
};
</script>